import {ClickEvent} from "../../infrastructure/models/analytics/click-event";
import {APP} from "../app/consts";

const TYPE_MORE = 'more';
const TYPE_LESS = 'less';

export class ShowMoreClickEvent extends ClickEvent {
  source: APP.ANALYTICS.SOURCES;
  gameId: Number;

  constructor(params) {
    super('click', 'show-more', 'match-details');

    this.source = params.source;
    this.gameId = params.gameId;
    this.type = params.isOpen ? TYPE_LESS : TYPE_MORE;
  }

  get properties() {
    const properties = super.properties;

    properties.section = this.source;
    properties.gameId = this.gameId;
    properties.type = this.type;

    return properties;
  }
}
